/* Wizard instances */
export const WIZARD_DEMO:string = 'demo';
export const WIZARD_COMPANY:string = 'company';
export const WIZARD_GLOBAL_PRODUCT_EDIT:string = 'globalproductEdit';
export const WIZARD_WEBSHOP:string = 'webshop';
export const WIZARD_COMPANY_PROFILES:string = 'companyprofiles';
export const WIZARD_BP_PROFILES:string = 'bpprofiles';
export const WIZARD_BP_WIZARD:string = 'bpwizard';
export const WIZARD_ORDER:string = 'order';